import Link from 'next/link';
import styled from 'styled-components';
import { inlineLink, theme } from '@frameio/vapor';

export const StyledLink = styled(Link)<{ $inlineBlock?: boolean }>`
  ${inlineLink};
  border: none;
  color: ${theme.colors.text.link};

  &:focus-visible,
  &:focus {
    text-decoration: underline;
  }

  ${(p) => p.$inlineBlock && 'display: inline-block'}
`;
